import * as TerrassorConst from '../../terrassor_const.js'

/* @ngInject */
export class ApiExo {
  /* @ngInject */
  constructor (TerrassorDB, $q) {
    // Injection des dépendances TerrassorDB et $q
    // on les enregistre sur 'this' afin de les reutiliser plus tard.
    this.TerrassorDB = TerrassorDB
    this.$q = $q
  }

/*
* @todo : lire l'id du chantier depuis la table simu_etudes (see simu_etudes.exo_chantiers_id)
*/
  getCurrentChantierID() {
    //return this.$q.resolve(TerrassorConst.CURRENT_CHANTIER_ID)
    return this.$q.resolve(TerrassorConst.chantierId) // BC 09/2017
  }

  /*
  */
  getChantierByCode(code) {
    if (!code) return this.$q.reject("Please pass a code for Chantier.")

    return this.TerrassorDB.getDbConnection()
    .then(db => {
        // On récupère la référence vers la table
        var t = this.TerrassorDB.tables.exo_chantiers
        var query
        query = db.select().from(t).where(t.code.eq(code)).exec()
        // On retourne la promesse de la requete
        return this.$q.resolve(query)
    })
  }


/*
* Cubature et mouvements associés
*/  getCubatureByCode(code) {
    if (!code) return this.$q.reject("Please pass a code for cubature.")

    var exoCubature
    return this.getExoCubature(code)
    .then(exoCubatures => {
      exoCubature = exoCubatures.pop()
      return this.getMouvementsForCubature(exoCubature)
    })
    .then(associatedMvts => {
      exoCubature.exo_mouvements = []
      associatedMvts.forEach(m => {
        m.exo_mouvements.ordre = m.exo_cubatures_exo_mouvements.ordre
        exoCubature.exo_mouvements.push(m.exo_mouvements)
      })
      return exoCubature
    })
  }

  getExoCubature(code) {
     if (!code) return this.$q.reject("Please pass a code for cubature.")

    return this.TerrassorDB.getDbConnection()
    .then(db => {
        var {exo_cubatures} = this.TerrassorDB.tables
        var query
        query = db.select()
        .from(exo_cubatures)
        .where(lf.op.and(
                  exo_cubatures.code.eq(code), 
                  //exo_cubatures.exo_chantiers_id.eq(TerrassorConst.CURRENT_CHANTIER_ID)))
                  exo_cubatures.exo_chantiers_id.eq(TerrassorConst.chantierId))) // BC 09/2017
        .exec()

        return this.$q.resolve(query)
    })
  }

  getMouvementsForCubature(exoCubature) {
     return this.TerrassorDB.getDbConnection()
    .then(db => {
        var {exo_cubatures_exo_mouvements} = this.TerrassorDB.tables
        var {exo_mouvements} = this.TerrassorDB.tables
        var query
        query = db.select()
        .from(exo_cubatures_exo_mouvements)
        .innerJoin(exo_mouvements, 
                      exo_mouvements.id.eq(exo_cubatures_exo_mouvements.exo_mouvements_id))
        .where(exo_cubatures_exo_mouvements.exo_cubatures_id.eq(exoCubature.id))
        .orderBy(exo_cubatures_exo_mouvements.ordre)
        //.groupBy(exo_cubatures_exo_mouvements.ordre) // marche pô !!
        .exec()

        return this.$q.resolve(query)
      })
  }




  // mouvement d'un exercice
  getMouvement (id) {
    if (!id) return this.$q.reject("Please pass an ID.")

    return this.TerrassorDB.getDbConnection().then(db => {
      // On récupère la référence vers la table
      var t = this.TerrassorDB.tables.exo_mouvements

      var query
      // query = db.select().from(t).where(t.id.eq(id)).exec()
      query = db.select().from(t).where(t.id.eq(id)).exec()

      // On retourne la promesse de la requete
      return this.$q.resolve(query)
    })
  }

  // mouvement d'un exercice
  getMouvementByCode (code, id_chantier) {
    if (!code) 
      return this.$q.reject("Please give me a code")

    //id_chantier = TerrassorConst.CURRENT_CHANTIER_ID;
    id_chantier = TerrassorConst.chantierId; // BC 09/2017
    return this.TerrassorDB.getDbConnection()    
   .then(db => {
      // On récupère la référence vers la table
      var t = this.TerrassorDB.tables.exo_mouvements
      var query
      query = db
        .select()
        .from(t)
        .where(lf.op.and(t.code.eq(code), t.exo_chantiers_id.eq(id_chantier)))
        .exec()
      // On retourne la promesse de la requete
      return this.$q.resolve(query)
    })
      .then(resultsArray => {
        return resultsArray.pop()
      })
  }


  getCubatureImmediate(cubId) {
      /*var t =  this.TerrassorDB.getJsonTable("exo_cubatures")
      console.log('getCubatureNameImmediate for id', cubId, t)
      var items = t.filter(item => item.id == cubId);

      console.log('getCubatureNameImmediate', items)
      return items.pop()*/
      return this.TerrassorDB.getRowInTableImmediate(cubId, 'exo_cubatures')
  }

  
  /*
  */
  getCubatureMouvementImmediate(exoCubId, exoMvtId) {

   var t =  this.TerrassorDB.getJsonTable('exo_cubatures_exo_mouvements')
   var items = t.filter(item => item.exo_cubatures_id == exoCubId && item.exo_mouvements_id == exoMvtId);
   return items ? items.pop() : null

  }

  getTypeSolImmediate(solId) {

    return this.TerrassorDB.getRowInTableImmediate(solId, 'const_sols' )
  }
  

} // end class ApiExo



// WEBPACK FOOTER //
// ./src/client/common/api/ApiExo.js